// product.js
// Action Creators for List operations

/****************************************************************
 * Actions
 ****************************************************************/
// Available Actions
export const PRODUCT_ADD    = 'PRODUCT_ADD';
export const PRODUCT_REMOVE = 'PRODUCT_REMOVE';
export const PRODUCT_RENAME = 'PRODUCT_RENAME';
export const UNIT_ADD       = 'UNIT_ADD';
export const UNIT_REMOVE    = 'UNIT_REMOVE';
export const UNIT_RENAME    = 'UNIT_RENAME';
export const UNIT_SET_PRICE = 'UNIT_SET_PRICE';


/****************************************************************
 * Action Creators
 ****************************************************************/
// Adds a new product with the given name
export function addProduct (name) {
  return {
    type: PRODUCT_ADD,
    name,
  }
}

// Removes a product with the given id
export function removeProduct (id) {
  return {
    type: PRODUCT_REMOVE,
    id,
  }
}

// Renames the product with the given id to 'name'
export function renameProduct (id, name) {
  return {
    type: PRODUCT_RENAME,
    id,
    name,
  }
}

// Adds a new unit of sale for a given product
export function addUnit (pId, name, price) {
  return {
    type: UNIT_ADD,
    productId: pId,
    name,
    price,
  }
}

// Removes a unit of sale for a given product
export function removeUnit (pId, uId) {
  return {
    type: UNIT_REMOVE,
    productId: pId,
    unitId: uId,
  }
}

// Renames a unit of sale for a given product
export function renameUnit (pId, uId, name) {
  return {
    type: UNIT_RENAME,
    productId: pId,
    unitId: uId,
    name,
  }
}

// Sets the base price for a unit of sale for a given product
export function setUnitPrice (pId, uId, price) {
  return {
    type: UNIT_SET_PRICE,
    productId: pId,
    unitId: uId,
    price,
  }
}



// WEBPACK FOOTER //
// ./src/actions/product.js